module.exports = __webpack_public_path__ + "img/hongmeng.d85489c1.png";